export enum CreateTreatmentInvoiceResult {
  Success = 1,
  CostMismatch = 2,
  PaidFailed = 3,
}
